export default {
  en: {
    loading: 'Loading',
    save: 'Save',
    publish: 'Publish',
    yes: 'Yes',
    no: 'No',
    view: 'View',
    ok: 'Ok',
    cancel: 'Cancel',
    edit: 'Edit {entity}',
    remove: 'Delete {entity}',
    confirm: 'Confirm',
    reports: 'See reports',
    suspend: 'Suspend',
    reload: 'Update',
    reset: 'Reset',
    filter: 'Filter',
    name: 'Name',
    empty: 'No data found. { extra }',
    create: 'Create {entity}',
    firstname: 'First Name',
    lastname: 'Last Name',
    email: 'Email',
    message: 'Message',
    privilege: 'Privilege',
    password: 'Password',
    passwordConfirm: 'Confirm password',
    default: 'Default',
    custom: 'Custom',
    start: 'Start',
    end: 'End',
    today: 'Today',
    minute: 'Minute || Minutes',
    hour: 'Hour || Hours',
    date: 'Date',
    install: 'Install',
    owner: 'Owner',
    copy: 'Copy',
    next: 'Next',
    back: 'Back',
    finish: 'Finish',
    deleting: {
      type: 'Please type in the {word} of the {entity} to confirm. | Please type the number {entity} for confirm the deletion.',
      undone: 'This action cannot be undone.',
      permanently: 'This will permanently delete the {entity} | This will permanently delete the {entity} selected',
      all: 'and all data associated.',
      sure: 'Are you sure you want remove this {entity}?',
      caution: 'Unexpected bad things will happen if you don’t read this!',
    },
    creating: {
      title: 'Create a new {entity}',
    },
    editing: {
      title: 'Edit {entity}',
    },
    deleted: {
      success: {
        title: '{entity} deleted | {entity} deleted',
        description: 'The {entity} {name} was deleted. | The {name} {entity} was deleted.',
      },
      fail: {
        title: 'Error deleting {entity} | Error deleting {entity}',
        description: 'The {entity} {name} cannot be deleted, please try again. | The {name} {entity} cannot be deleted, please try again.',
      },
    },
    langs: {
      es: 'Spanish',
      en: 'English',
    },
    contracts: {
      annual: 'Annual',
      monthly: 'Monthly',
      weekly: 'Weekly',
      quarterly: 'Quarterly',
      biannual: 'Biannual',
    },
    copied: {
      error: 'The code cannot be copied, please try manually',
      successful: 'The code was copied successful',
    },
  },
  es: {
    loading: 'Cargando',
    save: 'Guardar',
    publish: 'Publicar',
    yes: 'Si',
    no: 'No',
    view: 'Ver',
    ok: 'Aceptar',
    cancel: 'Cancelar',
    edit: 'Editar {entity}',
    remove: 'Eliminar {entity}',
    confirm: 'Confirmar',
    reports: 'Ver reportes',
    suspend: 'Suspender',
    reload: 'Actualizar',
    reset: 'Limpiar',
    filter: 'Filtrar',
    name: 'Nombre',
    empty: 'No se han encontrado datos. { extra }',
    create: 'Crear {entity}',
    firstname: 'Nombre',
    lastname: 'Apellido',
    email: 'Correo electrónico',
    message: 'Mensaje',
    privilege: 'Privilegio',
    password: 'Contraseña',
    passwordConfirm: 'Confirme contraseña',
    default: 'Predeterminado',
    custom: 'Personalizado',
    start: 'Inicio',
    end: 'Fin',
    today: 'Hoy',
    minute: 'Minuto || Minutos',
    hour: 'Hora || Horas',
    date: 'Fecha',
    install: 'Instalar',
    owner: 'Propietario',
    copy: 'Copiar',
    next: 'Siguiente',
    back: 'Retroceder',
    finish: 'Finalizar',
    deleting: {
      type: 'Escriba el {word} del {entity} para confirmar. | Escriba el número {entity} para confirmar la eliminación.',
      undone: 'Esta acción no se puede deshacer.',
      permanently: 'Esto eliminará permanentemente el {entity} | Esto eliminará permanentemente los {entity} seleccionados',
      all: 'y todos los datos asociados.',
      sure: 'Está seguro que desea eliminar este {entity}? | Está seguro que desea eliminar estos {entity}?',
      caution: '¡Cosas malas e inesperadas sucederán si no lee esto!',
    },
    creating: {
      title: 'Crear un nuevo {entity}',
    },
    editing: {
      title: 'Editar {entity}',
    },
    deleted: {
      success: {
        title: 'El {entity} fue eliminado | Los {entity} fueron eliminados',
        description: 'El {entity} {name} fue eliminado. | Los {name} {entity} fueron eliminados.',
      },
      fail: {
        title: 'Error eliminando el {entity} | Error eliminando los {entity}',
        description: 'No se ha podido eliminar el {entity} {name}, intente nuevamente. | No se ha podido eliminar {name} {entity}, intente nuevamente.',
      },
    },
    langs: {
      es: 'Español',
      en: 'Inglés',
    },
    contracts: {
      annual: 'Anual',
      monthly: 'Mensual',
      weekly: 'Semanal',
      quarterly: 'Trimestral',
      biannual: 'Semestral',
    },
    copied: {
      error: 'El código no se puede copiar, intente manualmente',
      successful: 'El código fue copiado exitosamente',
    },
  },
};
